import React from 'react';
import {Platform} from 'react-native';
import Menu from './Menu';

type OverflowMenuProps = React.ComponentProps<typeof Menu>;

const OverflowMenu = ({
  placement = Platform.OS === 'web' ? 'right top' : 'left bottom',
  shouldFlip = true,
  ...props
}: OverflowMenuProps) => {
  return <Menu placement={placement} shouldFlip={shouldFlip} {...props} />;
};

export default OverflowMenu;
